<template>
  <div class="ai-loader" :style="paddingStyle">
    <div class="progress-bar ai-background" :style="progressStyle"></div>
  </div>
</template>

<script>
export default {
  name: "ai-loader",
  props: {
    duration: {
      type: Number,
      default: 5000 // default 5 seconds
    },
    height: {
      type: Number,
      default: 6 // default 6px
    }
  },
  data() {
    return {
      progress: 0
    };
  },
  computed: {
    progressStyle() {
      return {
        width: `${this.progress}%`,
        height: `${this.height}px`,
        transition: `width ${this.duration}ms cubic-bezier(0.8, 0, 0.1, 1)`
      };
    },
    paddingStyle() {
      return {
        padding: `${this.height / 2}px`
      };
    }
  },
  mounted() {
    
    requestAnimationFrame(() => {
      this.progress = 0;
      requestAnimationFrame(() => {
        this.progress = 90;
      });
    });
  }
};
</script>

<style scoped>
.ai-loader {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f0f0;
}

.progress-bar {
  width: 0;
  border-radius: 2px;
  animation: animateBackground 5s linear infinite;
}
</style>
